import { render, staticRenderFns } from "./RltdPointsPanel.vue?vue&type=template&id=67c6c81a&scoped=true"
import script from "./RltdPointsPanel.vue?vue&type=script&lang=js"
export * from "./RltdPointsPanel.vue?vue&type=script&lang=js"
import style0 from "./RltdPointsPanel.vue?vue&type=style&index=0&id=67c6c81a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c6c81a",
  null
  
)

export default component.exports